<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;min-height:calc(100vh - 299px);position:relative ;background-color: #fff;margin-bottom: 40px;">

			<div class="itemTitle">阳泉高新区科创资源汇总<span>（ 数据来自{{nowYear}}年 ）</span></div>
			<div class="serchTop">
				<a-input-search
				size="large"
      v-model:value="companyNameSerch"
      placeholder="请输入企业名称"
      enter-button
      @search="getCompanyPoints"
    />
			</div>
			<div class="hotMapTop flex">
				<div v-if="titleData" class="flex1"  :class="{topActive:topBtn==4}" @click="topBtnfun(4,true)">
					<p>{{titleData.data[4].value}}<span>家</span></p><p>{{titleData.data[4].name}}</p>
				</div>
				<div v-if="titleData" class="flex1" :class="{topActive:topBtn==0}" @click="topBtnfun(0,true)">
					<p>{{titleData.data[0].value}}<span>家</span></p><p>{{titleData.data[0].name}}</p>
				</div>
				<div v-if="titleData" class="flex1"  :class="{topActive:topBtn==1}" @click="topBtnfun(1,true)">
					<p>{{titleData.data[1].value}}<span>家</span></p><p>{{titleData.data[1].name}}</p>
				</div>
				<div v-if="titleData" class="flex1"  :class="{topActive:topBtn==2}" @click="topBtnfun(2,true)">
					<p>{{titleData.data[2].value}}<span>家</span></p><p>{{titleData.data[2].name}}</p>
				</div>
				<div v-if="titleData" class="flex1"  :class="{topActive:topBtn==3}" @click="topBtnfun(3,true)">
					<p>{{titleData.data[3].value}}<span>家</span></p><p>{{titleData.data[3].name}}</p>
				</div>
			</div>
			<div class="hotMapcon">
				<div v-if="rightList" class="ShowCompanyData">
					<h3 v-if="rightNameShow">{{rightNameShow.name}} - <span>{{rightNameShow.data.length}}家</span></h3>
					<div class="conData" v-if="changeTData">
						<p @click="selectPoint(item.company.companyName,item.company.stitchAddresses,item.lng,item.lat,key)" :class="{pactive:selectK==key}" v-for="(item,key) in tData.data" :key="key">
							<span>●</span>{{ item.company.companyName }}
						</p>
					</div>
				</div>
				<div class="hotMapBtn">
					<span   @click="closeMesFroIframe(tData)" :class="{activeBtn:showBtn==0}">分布图</span>
					<span   @click="sendMesFroIframe(tData)" :class="{activeBtn:showBtn==1}">热力图</span>
				</div>
				<iframe
					id="iframe_key"
					ref="mainIframeHot"
					v-if="iframeOn==0"
					src="static/indexHot.html"
					frameborder="0"
					style="width:100%;height:100vh"
				></iframe>
				<iframe
					id="iframe_key"
					ref="mainIframe"
					v-if="iframeOn==1"
					src="static/index.html"
					frameborder="0"
					style="width:100%;height:100vh"
				></iframe>
			</div>

		</div>
		<LayoutFooter />
	</div>
</template>

<script>
import { dictMixin } from "@/mixins";
import { login_mp, sys_admin, file_service, companyPointsSystem} from "@/api/adminService";
import axios from "axios";
import { ls } from "@/utils/util"
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
	name: "index",
	components: {
		LayoutFooter,
	},
	mixins: [dictMixin],
	data() {
		return {
			nowYear:new Date().getFullYear(),
			rightNameShow:null,
			changeTData: true,
			titleData: null,
			topBtn:4,
			showBtn: 0,
			rightList: false,
			all_logo: '',
			dictNames: 'policy_type',
			user: {},
			platformName,
			redirectPath: '/',
			iframeOn:null,
			tData:[],
			selectK:null,
			companyNameSerch: null,
			typeData:'A',
			tokenData: null,
		}
	},
	methods: {
		getChildPoint(x,y){
			for (let index = 0; index < this.tData.data.length; index++) {
				if(x==this.tData.data[index].lng && y==this.tData.data[index].lat){
						this.selectPoint(this.tData.data[index].company.companyName,this.tData.data[index].company.stitchAddresses,this.tData.data[index].lng,this.tData.data[index].lat,index)
				}

			}
		},
		selectPoint(title,arr,x,y,key){
			this.selectK = key
				if(this.iframeOn==0){
						const mapFrameHot = this.$refs['mainIframeHot'];
						mapFrameHot.contentWindow.openInfo(title,arr,x,y);
				}else{
						const mapFrame = this.$refs['mainIframe'];
						mapFrame.contentWindow.openInfo(title,arr,x,y);
				}
		},
		topBtnfun(e,bool){
			if(bool){
				this.rightList = true
			}
			if(e==0){
				this.typeData='A'
			}else if(e==1){
				this.typeData='B'
			}else if(e==2){
				this.typeData='C'
			}else if(e==3){
				this.typeData='D'
			}
			this.iframeOn = null
			this.changeTData = false
			this.topBtn = e
			this.tData = this.titleData.data[e]
			this.rightNameShow = this.titleData.data[e]
			this.closeMesFroIframe(this.tData)
		},
		getCompanyPoints() {
			// this.getAction({
			// 	url: companyPointsSystem.getCorporateHeatMap,
			// 	params:{
			// 		type:this.typeData,
			// 		companyName:this.companyNameSerch
			// 	}
			let currentUrl = window.location.href;
			this.tokenData = currentUrl.split('=')[1]
			axios({
        methods: "get",
        url: companyPointsSystem.getCorporateHeatMap,
        params:{
					type:this.typeData,
					companyName:this.companyNameSerch
				},
        responseType: 'json',
        headers: {
          Authorization: 'Bearer ' + this.tokenData
        }
			}).then(res => {
				if(res.data.code==601){
					window.location.href = 'https://www.yqgxqsc.com/manage/login'
				}
        if (res.data.data.data&&res.data.data.data.length>=4){
          this.titleData = res.data.data
          this.tData = this.titleData.data[4]
          this.rightNameShow = this.titleData.data[4]
          //   console.log(123)
        }
        console.log(res.data.data.data,173);
        this.$nextTick(() => {
          console.log(this.tData,175);
          this.closeMesFroIframe(this.tData)
          this.topBtnfun(this.topBtn)
        });
			})
		},
		sendMesFroIframe(tdata) {
			console.log(tdata, 182);
			this.showBtn = 1;
			this.iframeOn = 0;
			// 缓存待发数据
			this._pendingHeatData = JSON.parse(JSON.stringify(tdata));

			// 移除旧的监听器（防止重复绑定）
			if (this._heatIframeReadyHandler) {
				window.removeEventListener('message', this._heatIframeReadyHandler);
			}

			// 监听 iframe 初始化完成的 ready 消息，收到后再发数据
			this._heatIframeReadyHandler = (e) => {
				if (e.data && e.data.type === 'heatmap-iframe-ready') {
					window.removeEventListener('message', this._heatIframeReadyHandler);
					this._heatIframeReadyHandler = null;
					this.$nextTick(() => {
						const mapFrame = this.$refs['mainIframeHot'];
						if (mapFrame && this._pendingHeatData) {
							mapFrame.contentWindow.postMessage(this._pendingHeatData, '*');
							console.log('热力图数据已发送至iframe');
						}
					});
				}
			};
			window.addEventListener('message', this._heatIframeReadyHandler);
    },
		closeMesFroIframe(tdata){
			console.log(tdata,197);
			this.changeTData = true
			this.showBtn = 0;
			this.iframeOn = 1
			setTimeout(() => {

      // 向iframe传值
      const mapFrame1 = this.$refs['mainIframe'];
      const iframeWin1 = mapFrame1.contentWindow;
      iframeWin1.postMessage(
        JSON.parse(JSON.stringify(tdata)),
        '*'
      );
			}, 500);

		},
		logout() {
			let self = this;

			self.$ls.clear();
			self.$store.commit('setMenuData', []);
			self.$router.replace('/');

			location.reload();
		},
		onLogout() {
			let self = this;
			self.$confirm({
				title: '确认要退出登录?',
				content: '',
				onOk() {
					self.postAction({
						url: login_mp.saveLog,
						params: { logAppCategoryEnum: "LOGOUT" }
					}).then(res => {
						console.log(res)
						self.getAction({
							url: login_mp.logout,
							params: { access_token: ls.get("token") || "" },
							isValid: false
						}).then(() => {
							self.$notification['success']({
								message: '退出成功',
                                style: {
                                    fontWeight: '600',
                                },
							});
						})
					})


					setTimeout(() => {
						self.logout();
					}, 2000)
				},
				onCancel() {
				},
			});
		},
		getUserInfo() {
			this.getAction({
				url: sys_admin.userInfor
			}).then(res => {
				sessionStorage.setItem("roleCode", res.roleCode.split(','));
			})
		},
		goHttp(url) {
			window.open(url, '_bank')
		},

    islogin() {
      if (ls.get("token") && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
		goMore(url, str) {
			this.$router.push({ path: url, query: { id: str } })
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		}
	},
	mounted() {
		window.getChildPoint = this.getChildPoint;// 这里需要暴露给全局，这样的话，子页面才能调用相对应的方法
		this.getCompanyPoints()
		if (ls.get('token') && ls.get("refresh_token")) {
			this.user.userName = this.$ls.get('userName')
			this.user.phoneNumber = this.$ls.get('phoneNumber')
		}
		this.all_logo = this.$ls.get('all_logo');
	},
	beforeCreate() {
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background-color:#fff')
	}
	,
	beforeUnmount() {
		// 销毁背景色
		document.querySelector('body').removeAttribute('style')
	},
}
</script>

<style scoped lang="less">
.hotMapTop{
	margin:60px 0 40px;
	.flex1{
		flex:1;
		text-align: center;
		margin:0 2%;
		height: auto!important;
    background: rgba(64,158,255,.05);
    border: 1px solid rgba(64,158,255,.3);
    border-radius: 4px;
    overflow: hidden;
		padding: 9px 10px 13px;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #333;
		cursor: pointer;
		p{
			font-size: 16px;
			color:#333;
			&:nth-child(odd){
				font-size: 23px;
				color:#0a87df;
				span{
					font-size: 16px;
				}
			}
		}
		&:hover{
			transition: all .5s;
			background: #0a87df;
			p{
				color: #fff;
			}
		}

	}

	.topActive{
		transition: all .5s;
	background: #0a87df;
		p{
			color: #fff;
			&:nth-child(odd){
				font-size: 23px;
				color:#fff;
				span{
					font-size: 16px;
				}
			}
		}
	}
}
.hotMapcon{
	position: relative;
	width:96%;
	margin:0 auto;
	.ShowCompanyData{
		position: absolute;
		right:2%;
		top:40px;
		z-index: 99999999;
		background: rgba(255, 255, 255, 0.5);
		padding:22px;
		h3{
			position: absolute;
			border-left:4px solid #0a87df;
			padding: 0 10px;
			font-size: 18px;
			font-weight: 600;
			line-height: 18px;
			span{
				color:#0a87df
			}
		}
		.conData{
			margin-top: 23px;
			width: 350px;
			height:400px;
			overflow: auto;
		}
		p{
			font-size: 16px;
			cursor: pointer;
			color:#5a5a5a;
			border-bottom: 1px dashed #dbdbdb;
			line-height: 45px;
			font-family: '微软雅黑';
			&:hover{
				color:#0a87df!important
			}
			span{
				font-size: 8px;
				margin:0 5px;
			}
		}
		.pactive{
			color:#0a87df!important
		}
	}
	.hotMapBtn{
		position: absolute;
		left:45%;
		top:40px;
		z-index: 99999999;
		width: 200px;
		border-radius: 30px;
		border: 1px solid #0a87df;
		display: flex;
		overflow: hidden;
		span{
			flex: 1;
			text-align: center;
			padding:10px 0;
			cursor: pointer;
			background: #fff;
			&:hover{
				transition: all .5s;
				background: #0a87df;
				color: #fff;
			}
		}
		.activeBtn{
			transition: all .5s;
			background: #0a87df;
			color: #fff;
		}
	}
}
.serchTop{
	position: absolute;
	right:2%;
	top:3%;
}
.itemTitle{
	position: relative;
	text-align: center;
	font-size: 35px;
	span{
		position: absolute;
		margin:0 auto;
		color:#777;
		right:0;
		left:0;
		top:100%;
		font-size: 14px;
	}
	margin:20px 0;
	font-weight: 600;
	&:before {
		content: "";
		display: inline-block;
    width: 134px;
    height: 7px;
		background: url(../../assets/img/jf/left.png) no-repeat;
	}
	&:after {
		content: "";
		display: inline-block;
    width: 134px;
		margin-left: 20px;
    height: 7px;
		background: url(../../assets/img/jf/right.png) no-repeat;

	}
}
.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			cursor: pointer;
			overflow: hidden;
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 66px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			float: right;
			display: flex;
			justify-content: space-around;
			line-height: 92px;
			font-size: 16px;

			a {
				font-weight: 600;
			}

			.loginBox {
				// float: left;
				cursor: pointer;
			}

			.loginBox:hover {
				color: #fc550b;
			}

			.lineBox {
				height: 18px;
				top: 36px;
			}

			.resigierBox {
				cursor: pointer;
				// float: left;
			}

			.resigierBox:hover {
				color: #fc550b;
			}
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}



.floatBox {
	width: 100%;

	.textBox {
		width: 100%;
		height: 250px;
		background-image: url('../../assets/img/resigter.jpg');
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;

		.text {
			font-size: 30px;
			color: #fff;
			font-weight: 700;
		}
	}

	.midBox {
		position: relative;
		width: 100%;
		min-height: 50vh;

		.midFloatBox {
			overflow: hidden;
			width: 1200px;
			height: 100%;
			padding: 18px 15px 25px;
			margin: -40px auto 40px auto;
			background-color: #fff;
			box-shadow: 0 10px 15px rgba(37, 69, 167, .2);
			border-radius: 5px;

			.breadBox {
				// width: 1200px;
				margin: 3px 0 15px;
				font-size: 16px;
			}

			.tabBox {
				overflow: hidden;
				width: 100%;
				min-height: calc(100vh - 400px);
				margin: 0 auto;

				.code {
					text-align: center;
					height: 30px;
					background: #e2e2e2;
					line-height: 30px;
					font-size: 24px;
				}

				.layout-header {
					background-color: #ffffff;
					height: auto;
					padding-top: 30px;
				}

				//
				//.layout-content {
				//  background: url(../assets/img/login-bg.png) center center no-repeat #ffffff;
				//  padding: 60px 0;
				//}

				.layout-footer {
					background-color: #ffffff;
				}

				.container {
					//width: 90%;
					//height: 80%;
					margin-left: auto;
					margin-right: auto;
					padding-top: 30px;
					//padding-top: 48%;
					//background: url(../assets/img/login-image.png) center center no-repeat;
					//background-size: 80%;

				}

				.login-form {
					width: 70%;
					margin: 40px auto;

					h3 {
						margin: 0 0 30px;
						position: relative;
						padding-left: 15px;

						span {
							position: absolute;
							left: 0;
							display: block;
							height: 60%;
							top: 20%;
							width: 4px;
							background: #1890ff;
						}
					}
					.btnBB{
						width: 300px;
						margin: 0 auto;
					}
					:deep(.ant-form-item-label > label){
						font-size: 16px;
					}
				}

				.ant-col-10 {
					margin-top: -43%;
					margin-left: 12%;
				}

				.title {
					font-size: 60px;
					font-weight: 500;
					margin: 40px 0;
				}



				.vcode-img {
					display: block;
					width: 100%;
					height: 50px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.login-img {
					display: block;
					width: 100%;
				}

			}
		}

	}
}

.footerBox {
	width: 100%;
	background-color: #333333;

	.footerContent {
		position: relative;
		margin: 0 auto;
		padding: 24px 0;
		width: 1200px;

		.firstLine {
			padding: 8px 0;
			font-size: 14px;
			color: #999;

			span {
				margin-right: 18px;
			}
		}

		.footCode {
			position: absolute;
			right: 0;
			bottom: 12%;
			text-align: center;

			.footEwm {
				margin-bottom: 8px;
			}

			.footEwmTitle {
				color: #999;
			}
		}
	}
}

:deep(.ant-list-lg .ant-list-item) {
	padding: 16px 8px;
}
</style>
